import {Injectable}     from '@angular/core';
import {Resolve}        from '@angular/router';

import {User}           from './user';
import {UserService}    from "./user.service";


@Injectable()
export class UserResolve implements Resolve<User[]> {

	constructor(private service: UserService) {}

	resolve() {
		return this.service.getUsers();
	}

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.resolve.ts